import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core'
import { NavLink } from 'react-router-dom'

const styles = () => ({
  group: {
    display: 'inline-flex',
    width: 320,
    overflow: 'hidden',
    border: '1px solid var(--careco-border)',
    borderRadius: 'var(--careco-rounded-md, 12px)',
    background: 'var(--careco-surface)',
  },
  segment: {
    flex: '1 1 0',
    minWidth: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    padding: '10px 18px',
    fontFamily: 'var(--careco-font)',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: 1.2,
    color: 'var(--careco-text-secondary)',
    background: 'transparent',
    whiteSpace: 'nowrap',
    transition: 'background 120ms ease, color 120ms ease',
    '&:hover': { background: 'var(--careco-row-default)', color: 'var(--careco-text-primary)' },
    '&:focus-visible': {
      outline: '2px solid var(--careco-primary)',
      outlineOffset: -2,
    },
  },
  active: {
    background: 'var(--careco-primary-light)',
    color: 'var(--careco-primary)',
    '&:hover': {
      background: 'var(--careco-primary-light)',
      color: 'var(--careco-primary)',
    },
  },
  label: {
    display: 'inline-block',
  },
  count: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 6,
    minWidth: 22,
    height: 22,
    padding: '0 7px',
    boxSizing: 'border-box',
    borderRadius: 'var(--careco-rounded-pill, 999px)',
    fontSize: 12,
    fontWeight: 700,
    lineHeight: 1,
    fontVariantNumeric: 'tabular-nums',
    background: 'var(--careco-divider)',
    color: 'var(--careco-text-secondary)',
  },
  countActive: {
    background: 'var(--careco-surface)',
    color: 'var(--careco-primary)',
  },
  '@media (max-width: 600px)': {
    group: {
      width: '100%',
      maxWidth: '100%',
      display: 'flex',
    },
  },
})

const OrganisationScopeSwitch = ({
  classes,
  active,
  careHref,
  qcsHref,
  careCount,
  qcsCount,
  showQcs = true,
}) => {
  const segment = (key, href, label, count) => {
    const isActive = active === key
    return (
      <NavLink
        className={`${classes.segment} ${isActive ? classes.active : ''}`}
        to={href}
        aria-current={isActive ? 'page' : undefined}>
        <span className={classes.label}>{label}</span>
        {typeof count === 'number' && (
          <span className={`${classes.count} ${isActive ? classes.countActive : ''}`}>
            {count.toLocaleString()}
          </span>
        )}
      </NavLink>
    )
  }

  return (
    <div className={classes.group} role="group" aria-label="Organisation type">
      {segment('care', careHref, 'CareBrain', careCount)}
      {showQcs ? segment('qcs', qcsHref, 'QCS', qcsCount) : null}
    </div>
  )
}

OrganisationScopeSwitch.propTypes = {
  classes: PropTypes.object,
  active: PropTypes.oneOf(['care', 'qcs']),
  careHref: PropTypes.string,
  qcsHref: PropTypes.string,
  careCount: PropTypes.number,
  qcsCount: PropTypes.number,
  showQcs: PropTypes.bool,
}

export default withStyles(styles)(OrganisationScopeSwitch)
